<template>
  <div class="card-froms">
    <!-- <v-card>
    <v-card-subtitle class="pt-1"> -->
      <div v-if="course_fees!='NA'">
      <v-img src="https://vgespl-sbpps.s3.ap-south-1.amazonaws.com/logo/course/2.png" height="100px"></v-img>
    <br />
        This course includes:<br />
        <!-- Language - English <br /> -->
        <!-- Time - {{ videoDuration }}<br /> -->
        <span v-if="videoDuration !='-'">Time - {{ videoDuration }}<br /></span>
        <span v-else></span>
        <!-- Resource - {{ totalResources }} Downloadable  -->
        Includes {{ totalResources }} modules for study
        <br />
        <!-- Access - Full lifetime access <br /> -->
        <!-- Certification - On completion -->
        Certification on completion
      <!-- </v-card-subtitle>
    </v-card> -->
    <br>
    <br>
      </div>
    <form
      name="epnenrol"
      method="post"
      action=""
      enctype="multipart/form-data"
      v-on:submit.prevent="onSubmit()"
      id="ajaxForm"
      class="pl-4 pr-4"
    >
      <div class="input-group">
        <span class="input-group-addon" id="basic-addon1"
          ><i class="fa fa-user"> </i
        ></span>
        <input
          type="text"
          v-model="firstname"
          id="firstname"
          class="form-control col-sm-12"
          placeholder="First Name"
          aria-describedby="basic-addon1"
          required="required"
        />
      </div>
      <br />
      <div class="input-group">
        <span class="input-group-addon" id="basic-addon1"
          ><i class="fa fa-user"> </i
        ></span>
        <input
          type="text"
          v-model="lastname"
          id="lastname"
          class="form-control col-sm-12"
          placeholder="Last Name"
          aria-describedby="basic-addon1"
        />
      </div>
      <br />
      <div class="input-group">
        <span class="input-group-addon" id="basic-addon1"
          ><i class="fa fa-phone"> </i
        ></span>
        <input
          type="number"
          v-model="phoneno"
          id="phoneno"
          class="form-control col-sm-12"
          placeholder="Phone Number"
          aria-describedby="basic-addon1"
          required="required"
        />
      </div>
      <!-- <input
        type="hidden"
        name="id"
        id="id"
        value="certificate-course-in-machine-learning-using-python"
      />
      <input type="hidden" name="cap" id="cap" value="" /> -->
      <br />
      <div class="input-group">
        <span class="input-group-addon" id="basic-addon1"
          ><i class="fa fa-envelope"> </i
        ></span>
        <input
          type="email"
          v-model="email"
          class="form-control col-sm-12"
          placeholder="Email"
          required="required"
          aria-describedby="basic-addon1"
        />
      </div>
      <br />
      <center>
        <h6 v-if="course_fees!='NA'">
      <i class="fa fa-inr pri" ></i><b class="pri"> {{ course_fees }}</b
      ><span class="fee-gst pri" > (+GST)</span>
    </h6><br>
      <v-btn  type="submit" class="btn btn-rssdi" id="enroll" :loading="loader_signup"><b> {{btn_name}}</b></v-btn>
        <!-- <button type="submit"  class="btn btn-rssdi" id="enroll" >
          {{btn_name}}
        </button> -->
      </center>
    </form>
    
    <!-- OTP -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <form
            name="epnreg"
            method="post"
            action=""
            enctype="multipart/form-data"
            v-on:submit.prevent="signup()"
            id="ajaxForm_reg"
          >
            <v-card>
              <!-- <v-card-title>
                <span class="headline">Registration</span>
              </v-card-title> -->
              <v-toolbar dark color="#9e1b20">
            <v-toolbar-title>Registration</v-toolbar-title>
          </v-toolbar>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="OTP*"
                        v-model="otp"
                        dense
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        dense
                        v-model="password"
                        label="Password*"
                        type="password"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        dense
                        label="Confirm Password*"
                        type="password"
                        v-model="confirm_password"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
                <small>*indicates required field</small>
              </v-card-text>
              <v-card-actions>
                <v-btn rounded color="red" @click="dialog = false">
                  Close
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn type="submit" rounded class="green">Proceed</v-btn>
                <!-- <button type="submit" color="blue darken-1">Proceed</button> -->
              </v-card-actions>
            </v-card>
          </form>
        </v-dialog>
      </v-row>
    </template>
  </div>
</template>


<script>
import axios from 'axios'
import { load } from "recaptcha-v3";
export default {
  data: () => ({
    loader_signup:false,
      btn_name:"Sign Up",
    firstname: null,
    lastname:null,
    phoneno: null,
    email: null,
    dialog: false,
    //
    password: null,
    confirm_password: null,
    otp: null,
    crs_id:null,
  }),
  created(){
      if(this.course_fees=='NA')
        this.btn_name="Sign Up"
      else
        this.btn_name="Get The Course"
  },
  props: ["course_fees","totalResources", "videoDuration","crs_id"],
  methods: {
    login(){
      this.$router.push({ name: "rssdi-login" });
      return
    },
    showsnackbar(msg, color, to) {
      this.$store.dispatch("setSnackbar", {
        showing: true,
        timeout: to,
        color: color,
        text: msg,
      });
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showsnackbar(msg, "error", 5000);
    },
    signup() {
        
      // console.log("data", this.$store.getters.rssdi_data);
      if (!this.password) {
        this.showsnackbar("enter password", "error", 5000);
        return;
      } else if (!this.confirm_password) {
        this.showsnackbar("enter confirm password", "error", 5000);
        return;
      } else if (!this.otp) {
        this.showsnackbar("enter confirm otp", "error", 5000);
        return;
      } else if (this.password != this.confirm_password) {
        this.showsnackbar("enter password mis-matched", "error", 5000);
        return;
      }
      this.dialog = false
      let data = {
        user_data:this.$store.getters.rssdi_data,
        otp:this.otp,
        password:this.password,
        tenantid:'rssdi',//'rssdi',
        // orgid:"4"
        orgid:localStorage.getItem('organization-code')
      }
      if (this.$session.exists()) {
            this.$session.destroy();
        }
      axios.defaults.baseURL = process.env.VUE_APP_API_URL_Home
      axios
        .post("/SignUp/process", data)
        .then((res) => {
            // console.log("res",res)
            // console.log("res.data",res.data)
            if(res.data.flag == "YES"){
                console.log("suss")
                this.$session.start();
                console.log("start")
                            //alert("UT :"+res.data.ut)
                this.$session.set("ut", "Learner");
                this.$session.set("token", res.data.token);
                this.$session.set("uid", res.data.uid);
                this.$session.set("device", res.data.device);
                this.$session.set("path", res.data.path);
                this.$session.set("vpath", res.data.vpath);
                axios.defaults.baseURL = process.env.VUE_APP_API_URL_Stud
                // console.log("start",this.$router)
                // console.log("start...")
                //this.$router.push({ name: "courses-catalog-rssdi" });
                this.$router.push({ name: "join-new-course" });
                // console.log("bye")
                return
            }
            else{
                console.log("error")
                this.showsnackbar(res.data.snackbar, "error", 5000);
            }
        })
        .catch((error) => {
            console.log("Err",error)
            this.onerror(error)
        })
        .finally(() => {
            console.log("Error")
        });   
    },

    async onSubmit() {
      this.loader_signup=true
     // const recaptcha = await load("6Ld_0XYaAAAAAGwNBbBmit9xHlNBeH9kGMKxyXIb");
      //const token = await recaptcha.execute("login");
      // console.log(token); // Will also print the token
      let data = {
        firstname: this.firstname,
        email: this.email,
        lastname: this.lastname,
        phoneno: this.phoneno,
        tenantid: "rssdi",  //common
       // recaptcha_token: token,
      };
      // console.log("data", data);
      this.$store.commit("setrssdi_data", data);
      // console.log("data", this.$store.getters.rssdi_data);
        this.$session.set("user-data", JSON.stringify(data));
      //call api to verify token and get otp
      document.getElementById('enroll').disabled=true
      // document.getElementById('enroll').value="Processing"
      this.saveData()
      axios
        .post("/SignUp/generateOTP", data)
        .then((res) => {
            if(res.data.flag == "YES"){
              // this.showsnackbar("Captcha Verified...", "success", 5000);
              this.dialog = true;
            }else if(res.data.flag == "NO"){
              this.showsnackbar("Captcha Not Verified...", "error", 5000);
            }
            else if(res.data.flag == "AR"){
              this.showsnackbar("Already Registered...", "error", 5000);
              this.$router.push({ name: "rssdi-login" });
            }
            this.loader_signup=false
            document.getElementById('enroll').disabled=false
          //  document.getElementById('enroll').value=this.btn_name
        })
        .catch((error) => {
            this.onerror(error)
            this.loader_signup=false
            document.getElementById('enroll').disabled=false
          // document.getElementById('enroll').value=this.btn_name
        })
        .finally(() => {
        });   
      //on success
    },
    // for saving user data in lead manager
      saveData() {
      // this.loader_signup = true;
      // console.log(token); // Will also print the token
      let data = {
        firstname: this.firstname,
        email: this.email,
        lastname: this.lastname,
        phoneno: this.phoneno,
        course:this.crs_id,
        orgid: "1",
        tenantid: "rssdi",  //common
      };
      // console.log("data", data);
      axios.defaults.baseURL = process.env.VUE_APP_API_URL_Home;
      axios
        .post("/Rssdi/saveUserData", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            // this.showsnackbar("Your data has been saved...", "success", 5000);
            document.getElementById("ajaxForm").reset();
            this.dialog = true;
          } else if (res.data.flag == "NO") {
            // this.showsnackbar("Please try again later!", "error", 5000);
            document.getElementById("ajaxForm").reset();
          }
          // else if (res.data.flag == "ALREADYPRESENT") {
          //   // this.showsnackbar("You've already enrolled to this course!", "error", 5000);
          //   document.getElementById("ajaxForm").reset();
          // }
        })
        .catch((error) => {
           console.log("Err", error);
          // this.onerror(error);
          // this.loader_signup = false;
          document.getElementById('enroll').disabled=false
          // document.getElementById('enroll').value=this.btn_name
        })
        .finally(() => {
           console.log("Err");
        });
    },
  },
};
</script>

<style scoped>
.box {
  /* background-color: #c9d8dd59; */
  margin: 8px !important;
  padding: 8px;
  border: 2px solid rgb(195, 214, 218) !important;
}
.toolbar {
  text-align: center !important;
  background-color: #424093 !important;
  color: #ffffff !important;
}
.button {
  border: 2px solid #424093 !important;
  color: #424093;
  background: transparent !important;
  border-radius: 50px;
  margin: 0.5rem !important;
}
.button:hover {
  color: white;
  background: #424093 !important;
}
.crs-name {
  padding: 2rem 0rem 0rem 3rem;
}
@media only screen and (max-width: 600px) {
  .crs-name {
    padding: 2rem 2rem 0rem 3rem;
  }

  .p-0 {
    padding: 0;
  }
}
.info-title {
  font-weight: bold;
  font-size: 15px;
  color: black;
}
.input-group input {
  border-width: 1px;
  border-top-left-radius: 15px !important;
  border-top-right-radius: 15px !important;
}
.input-group-addon i {
  position: relative;
  top: 8px;
  right: 8px;
  color:#9e1b20;
}
.pri{
color:#424093; 
}
.btn-rssdi {
  background: #9e1b20 0% 0% no-repeat padding-box !important;
  border-radius: 10px;
  color: #ffffff;
}
.btn-rssdi:hover {
  background: #3b55b3 0% 0% no-repeat padding-box;
  border-radius: 30px;
  color: #ffffff !important;
}
</style>
